module.exports = __webpack_public_path__ + "img/a6.5a5de1d9.png";